"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_init_1 = require("@comunica/bus-init");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");

var core_1 = require("@comunica/core");

var asyncreiterable_1 = require("asyncreiterable");

var rdf_string_1 = require("rdf-string");

var rdf_terms_1 = require("rdf-terms");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A browser-safe comunica SPARQL Init Actor.
 */


var ActorInitSparql =
/*#__PURE__*/
function (_bus_init_1$ActorInit) {
  _inherits(ActorInitSparql, _bus_init_1$ActorInit);

  function ActorInitSparql(args) {
    _classCallCheck(this, ActorInitSparql);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorInitSparql).call(this, args));
  }
  /**
   * Create a copy of the given operation in which all given bindings are applied.
   * The bindings are applied to all quad patterns and path expressions.
   *
   * @param {Operation} operation An operation.
   * @param {Bindings} initialBindings Bindings to apply.
   * @return {Operation} A copy of the given operation where all given bindings are applied.
   */


  _createClass(ActorInitSparql, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
    /**
     * Evaluate the given query
     * @param {string | Algebra.Operation} query A query string or algebra.
     * @param context An optional query context.
     * @return {Promise<IActorQueryOperationOutput>} A promise that resolves to the query output.
     */

  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_query, context) {
        var key, existingEntry, queryFormat, baseIRI, combinationPromise, operation, bindings, resolve, output;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = context || {}; // Expand shortcuts

                for (key in context) {
                  if (this.contextKeyShortcuts[key]) {
                    existingEntry = context[key];
                    context[this.contextKeyShortcuts[key]] = existingEntry;
                    delete context[key];
                  }
                } // Set the default logger if none is provided


                if (!context[core_1.KEY_CONTEXT_LOG]) {
                  context[core_1.KEY_CONTEXT_LOG] = this.logger;
                }

                if (!context[bus_query_operation_1.KEY_CONTEXT_QUERY_TIMESTAMP]) {
                  context[bus_query_operation_1.KEY_CONTEXT_QUERY_TIMESTAMP] = new Date();
                } // Ensure sources are an async re-iterable


                if (Array.isArray(context[bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES])) {
                  // TODO: backwards compatibility
                  context[bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES].map(function (source) {
                    if (typeof source !== 'string' && (source.type === 'auto' || source.type === 'hypermedia')) {
                      delete source.type;
                    }
                  });
                  context[bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES] = asyncreiterable_1.AsyncReiterableArray.fromFixedData(context[bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES]);
                } // Prepare context


                context = core_1.ActionContext(context);
                queryFormat = 'sparql';

                if (context && context.has(exports.KEY_CONTEXT_QUERYFORMAT)) {
                  queryFormat = context.get(exports.KEY_CONTEXT_QUERYFORMAT);
                  context = context.delete(exports.KEY_CONTEXT_QUERYFORMAT);

                  if (queryFormat === 'graphql' && !context.has(exports.KEY_CONTEXT_GRAPHQL_SINGULARIZEVARIABLES)) {
                    context = context.set(exports.KEY_CONTEXT_GRAPHQL_SINGULARIZEVARIABLES, {});
                  }
                }

                if (context && context.has(bus_query_operation_1.KEY_CONTEXT_BASEIRI)) {
                  baseIRI = context.get(bus_query_operation_1.KEY_CONTEXT_BASEIRI);
                } // Start, but don't await, context pre-processing


                combinationPromise = this.mediatorContextPreprocess.mediate({
                  context: context
                }); // Parse query

                if (!(typeof _query === 'string')) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return this.mediatorSparqlParse.mediate({
                  context: context,
                  query: _query,
                  queryFormat: queryFormat,
                  baseIRI: baseIRI
                });

              case 13:
                operation = _context2.sent.operation;
                _context2.next = 17;
                break;

              case 16:
                operation = _query;

              case 17:
                _context2.next = 19;
                return combinationPromise;

              case 19:
                context = _context2.sent.context;

                // Apply initial bindings in context
                if (context.has(exports.KEY_CONTEXT_INITIALBINDINGS)) {
                  bindings = context.get(exports.KEY_CONTEXT_INITIALBINDINGS);
                  operation = ActorInitSparql.applyInitialBindings(operation, bus_query_operation_1.ensureBindings(bindings));
                } // Optimize the query operation


                _context2.next = 23;
                return this.mediatorOptimizeQueryOperation.mediate({
                  context: context,
                  operation: operation
                });

              case 23:
                operation = _context2.sent.operation;
                // Execute query
                resolve = {
                  context: context,
                  operation: operation
                };
                _context2.next = 27;
                return this.mediatorQueryOperation.mediate(resolve);

              case 27:
                output = _context2.sent;
                output.context = context;
                return _context2.abrupt("return", output);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function query(_x2, _x3) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
    /**
     * @param context An optional context.
     * @return {Promise<{[p: string]: number}>} All available SPARQL (weighted) result media types.
     */

  }, {
    key: "getResultMediaTypes",
    value: function () {
      var _getResultMediaTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(context) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.mediatorSparqlSerializeMediaTypeCombiner.mediate({
                  context: context,
                  mediaTypes: true
                });

              case 2:
                return _context3.abrupt("return", _context3.sent.mediaTypes);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getResultMediaTypes(_x4) {
        return _getResultMediaTypes.apply(this, arguments);
      }

      return getResultMediaTypes;
    }()
    /**
     * Convert a query result to a string stream based on a certain media type.
     * @param {IActorQueryOperationOutput} queryResult A query result.
     * @param {string} mediaType A media type.
     * @param {ActionContext} context An optional context.
     * @return {Promise<IActorSparqlSerializeOutput>} A text stream.
     */

  }, {
    key: "resultToString",
    value: function () {
      var _resultToString = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(queryResult, mediaType, context) {
        var handle;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                context = core_1.ActionContext(context);

                if (mediaType) {
                  _context4.next = 11;
                  break;
                }

                _context4.t0 = queryResult.type;
                _context4.next = _context4.t0 === 'bindings' ? 5 : _context4.t0 === 'quads' ? 7 : 9;
                break;

              case 5:
                mediaType = 'application/json';
                return _context4.abrupt("break", 11);

              case 7:
                mediaType = 'application/trig';
                return _context4.abrupt("break", 11);

              case 9:
                mediaType = 'simple';
                return _context4.abrupt("break", 11);

              case 11:
                handle = queryResult;
                handle.context = context;
                _context4.next = 15;
                return this.mediatorSparqlSerialize.mediate({
                  context: context,
                  handle: handle,
                  handleMediaType: mediaType
                });

              case 15:
                return _context4.abrupt("return", _context4.sent.handle);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function resultToString(_x5, _x6, _x7) {
        return _resultToString.apply(this, arguments);
      }

      return resultToString;
    }()
    /**
     * Invalidate all internal caches related to the given page URL.
     * If no page URL is given, then all pages will be invalidated.
     * @param {string} url The page URL to invalidate.
     * @return {Promise<any>} A promise resolving when the caches have been invalidated.
     */

  }, {
    key: "invalidateHttpCache",
    value: function invalidateHttpCache(url) {
      return this.mediatorHttpInvalidate.mediate({
        url: url
      });
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(action) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                throw new Error('ActorInitSparql#run is not supported in the browser.');

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function run(_x8) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }], [{
    key: "applyInitialBindings",
    value: function applyInitialBindings(operation, initialBindings) {
      var copiedOperation = {};

      for (var _i = 0, _Object$keys = Object.keys(operation); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (Array.isArray(operation[key])) {
          if (key === 'variables') {
            copiedOperation[key] = operation[key].filter(function (variable) {
              return !initialBindings.has(rdf_string_1.termToString(variable));
            });
          } else {
            copiedOperation[key] = operation[key].map(function (subOperation) {
              return ActorInitSparql.applyInitialBindings(subOperation, initialBindings);
            });
          }
        } else if (operation[key] && ActorInitSparql.ALGEBRA_TYPES[operation[key].type]) {
          copiedOperation[key] = ActorInitSparql.applyInitialBindings(operation[key], initialBindings);
        } else {
          copiedOperation[key] = operation[key];
        }

        if (operation.type === sparqlalgebrajs_1.Algebra.types.PATTERN || operation.type === sparqlalgebrajs_1.Algebra.types.PATH) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = rdf_terms_1.QUAD_TERM_NAMES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var quadTerm = _step.value;

              if (!(operation.type === sparqlalgebrajs_1.Algebra.types.PATH && quadTerm === 'predicate')) {
                var term = operation[quadTerm];

                if (term.termType === 'Variable') {
                  var termString = rdf_string_1.termToString(term);
                  var binding = initialBindings.get(termString);

                  if (binding) {
                    copiedOperation[quadTerm] = binding;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }

      return copiedOperation;
    }
  }]);

  return ActorInitSparql;
}(bus_init_1.ActorInit);

ActorInitSparql.ALGEBRA_TYPES = Object.keys(sparqlalgebrajs_1.Algebra.types).reduce(function (acc, key) {
  acc[sparqlalgebrajs_1.Algebra.types[key]] = true;
  return acc;
}, {});
exports.ActorInitSparql = ActorInitSparql;
exports.KEY_CONTEXT_INITIALBINDINGS = '@comunica/actor-init-sparql:initialBindings';
exports.KEY_CONTEXT_QUERYFORMAT = '@comunica/actor-init-sparql:queryFormat';
exports.KEY_CONTEXT_GRAPHQL_SINGULARIZEVARIABLES = '@comunica/actor-init-sparql:singularizeVariables';